"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CalendarTable = _interopRequireDefault(require("./CalendarTable"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll"
  },
  month: {},
  date: {
    "& + $date": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    }
  },
  dateButton: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    margin: 0,
    fontFamily: "Akkurat, sans-serif",
    fontSize: '12px',
    color: theme.palette.text.disabled,
    lineHeight: 1,
    "&[data-month=true]": {
      color: theme.palette.text.primary
    },
    "&[data-today=true]": {
      border: "1px solid",
      borderColor: theme.palette.primary.main
    },
    "&[data-selected=true]": {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  }
}));

const EventsList = ({
  events
}) => {
  if (!events) {
    return false;
  }

  return _react.default.createElement("ul", null, events.map(event => {
    return _react.default.createElement("li", null, event.title);
  }));
};

const DateButton = ({
  selected,
  dt,
  dtMonth,
  onClick
}) => {
  const classes = useStyles();
  return _react.default.createElement(_IconButton.default, {
    className: classes.dateButton,
    onClick: onClick,
    "data-selected": selected,
    "data-month": dtMonth
  }, (0, _moment.default)(dt).format('D'));
};

const ScheduleDate = ({
  date,
  events = []
}) => {
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.date
  }, date, _react.default.createElement(EventsList, {
    events: events
  }));
};

const CalendarSchedule = (_ref) => {
  let eventsByDate = _ref.eventsByDate,
      props = _objectWithoutPropertiesLoose(_ref, ["eventsByDate"]);

  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.root
  }, Object.keys(eventsByDate).map(date => {
    const events = eventsByDate[date];
    return _react.default.createElement(ScheduleDate, {
      date: date,
      events: events
    });
  }));
};

var _default = CalendarSchedule;
exports.default = _default;
module.exports = exports.default;